export default function OpenLeft({ className, onClick, style }) {
  return (
    <svg
      width="45"
      height="34"
      viewBox="0 0 45 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={style}
    >
      <rect
        opacity="0.75"
        x="9.5"
        y="7.5"
        width="9"
        height="21"
        rx="0.5"
        stroke="currentColor"
      />
      <path
        opacity="0.75"
        d="M25 17.5L29 21.5M25 17.5L29 13.5M25 17.5L37.5 17.5"
        stroke="currentColor"
      />
    </svg>
  );
}
